import React from 'react';

const location = (props) => {
    return (
        <div id="contact" className="row info_row">
            <div className="col-6 info">
              <img className="contact_logo" src={`${process.env.REACT_APP_IMAGE_STORAGE}${props.icon_image_path}`} alt="logo" />
              <h6 className="pt-3">
                location: <br />
                {props.address}
              </h6>
              <br />
              <h6>t: {props.phone}</h6>
              <br />
              <h6>e: {props.email}</h6>
              <br />
              <h6>office hours: {props.working_hour}</h6>
              <br />
            </div>
            <div className="col-6 map">
              <iframe src={props.google_map} width="150%" height="450" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
    );
};

export default location;